// src/App.js
import React, { useState } from 'react';
import { Container, AppBar, Toolbar, Typography } from '@mui/material';
import InvoiceForm from './InvoiceForm';
import AddItemForm from './AddItemForm';
import InvoiceDetails from './InvoiceDetails';





function Addrechnungs() {
  const [currentInvoice, setCurrentInvoice] = useState(null);

  const handleInvoiceCreated = (invoice) => {
    // Assuming the backend returns the created invoice. If not, you might need to fetch it.
    setCurrentInvoice(invoice);
  };

  const handleItemAdded = (updatedInvoice) => {
    setCurrentInvoice(updatedInvoice);
  };

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">
            Invoice Manager
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
        <InvoiceForm onInvoiceCreated={handleInvoiceCreated} />
        {currentInvoice && (
          <>
            <AddItemForm invoiceId={currentInvoice.id} onItemAdded={handleItemAdded} />
            <InvoiceDetails invoice={currentInvoice} />
          </>
        )}
      </Container>
    </div>
  );
}

export default Addrechnungs;
